module.exports = __webpack_public_path__ + "static/media/brand-refresh-accessiblity.851636bd.svg";